import { GetterTree } from 'vuex'
import { State } from './interfaces'

export default {

} as GetterTree<State, any>
